import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [staffId, setStaffId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(staffId.trim(), password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-stretch bg-[#F8F9FA]">
      <div className="hidden flex-1 flex-col justify-between border-r border-border bg-zinc-900 p-12 lg:flex">
        <h1 className="font-display text-3xl font-extrabold text-white">RNA &amp; CO</h1>
        <div>
          <p className="font-display text-5xl font-extrabold leading-tight text-white">
            Engagement<br />Status 2026
          </p>
          <p className="mt-4 max-w-sm text-sm text-zinc-400">
            Track every client through Accounting, Audit and Taxation — with staff timesheets that
            keep stages current.
          </p>
        </div>
        <span className="text-xs uppercase tracking-[0.3em] text-zinc-500">Internal use only</span>
      </div>

      <div className="flex flex-1 items-center justify-center p-8">
        <form
          data-testid="login-form"
          onSubmit={submit}
          className="w-full max-w-sm border border-border bg-white p-8"
        >
          <h2 className="font-display text-2xl font-extrabold">Sign in</h2>
          <p className="mt-1 text-sm text-zinc-500">Use the staff ID given to you by the admin.</p>

          <div className="mt-6 space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-widest text-zinc-500">Staff ID</Label>
              <Input
                data-testid="login-staffid-input"
                type="text"
                autoComplete="username"
                required
                value={staffId}
                onChange={(e) => setStaffId(e.target.value)}
                className="mt-1.5 rounded-sm"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-zinc-500">Password</Label>
              <Input
                data-testid="login-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 rounded-sm"
              />
            </div>
          </div>

          {error && (
            <p data-testid="login-error" className="mt-4 border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
              {error}
            </p>
          )}

          <Button
            data-testid="login-submit-button"
            type="submit"
            disabled={busy}
            className="mt-6 w-full rounded-sm bg-black text-white hover:bg-zinc-800 hover:text-white"
          >
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
